import AddressAutocomplete from "./AddressAutocomplete";
import { APIProvider } from "@vis.gl/react-google-maps";

const AddressAutocompleteProvider = ({ address, setAddress, options, placeholder }) => {
    const REACT_APP_GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY

    return (
        <APIProvider apiKey={REACT_APP_GOOGLE_MAPS_KEY}>
            <AddressAutocomplete address={address} setAddress={setAddress} options={options} placeholder={placeholder}/>
        </APIProvider>
    );
  };

export default AddressAutocompleteProvider